var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddVirtualEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 294.897,
    y: 206.252,
    fill: "#278ECB",
    width: 19.563,
    height: 15.306
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.576,
    y: 206.252,
    fill: "#278ECB",
    width: 19.563,
    height: 15.306
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.327,
    y: 206.252,
    fill: "#278ECB",
    width: 19.563,
    height: 15.306
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#278ECB",
    d: "M360.639,165.373V88.948h-96.612l-48.054-37.926L167.97,88.948H71.323v76.355L31,197.114v219.805h268.381 c-4.43-4.639-8.409-9.712-11.849-15.149H46.306V216.155l112.04,86.657l-77.554,62.543l9.607,11.953l80.368-64.871l45.205,34.972 l45.135-34.903l2.988,2.415l11.692,9.434c1.407-5.281,3.266-10.372,5.525-15.254l-7.783-6.289l24.983-19.336L323.669,264 l31.741-24.583l30.247-23.419v37.682c5.264,0.869,10.372,2.154,15.306,3.822v-60.389L360.639,165.373z M71.323,216.137 l-20.049-15.514l20.049-15.81V216.137z M215.972,70.533l23.35,18.416h-46.699L215.972,70.533z M215.972,328.003L86.629,227.986 V104.324h258.774v123.454L215.972,328.003z M360.708,215.981v-31.098l19.892,15.671L360.708,215.981z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.493,
    y: 128.048,
    fill: "#278ECB",
    width: 196.967,
    height: 15.306
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.493,
    y: 167.15,
    fill: "#278ECB",
    width: 196.967,
    height: 15.306
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.493,
    y: 206.252,
    fill: "#278ECB",
    width: 100.221,
    height: 15.306
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    d: "M400.962,242.927c-4.969-1.442-10.077-2.571-15.306-3.301c-5.195-0.764-10.493-1.147-15.896-1.147 c-4.865,0-9.66,0.313-14.35,0.938c-42.842,5.525-78.127,35.546-91.314,75.504c-3.614,10.945-5.577,22.655-5.577,34.799 c0,18.78,4.691,36.518,12.943,52.05c2.832,5.334,6.081,10.389,9.694,15.149c20.344,26.755,52.484,44.058,88.603,44.058 c61.345,0,111.24-49.913,111.24-111.258C481,299.216,447.157,256.46,400.962,242.927z M369.76,447.079 c-27.658,0-52.641-11.588-70.379-30.16c-4.43-4.639-8.409-9.712-11.849-15.149c-9.573-15.063-15.115-32.922-15.115-52.05 c0-8.774,1.164-17.269,3.37-25.365c1.407-5.281,3.266-10.372,5.525-15.254c4.343-9.451,10.181-18.086,17.199-25.625 c7.227-7.783,15.723-14.385,25.156-19.475c13.725-7.418,29.43-11.623,46.091-11.623c5.42,0,10.719,0.452,15.896,1.303 c5.264,0.869,10.372,2.154,15.306,3.822c38.429,13.047,66.14,49.461,66.14,92.217 C467.101,403.403,423.443,447.079,369.76,447.079z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    d: "M369.759,408.333c-3.838,0-6.949-3.112-6.949-6.949V298.071c0-3.838,3.112-6.949,6.949-6.949s6.949,3.112,6.949,6.949 v103.313C376.709,405.221,373.597,408.333,369.759,408.333z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    d: "M421.416,356.676H318.103c-3.838,0-6.949-3.112-6.949-6.949s3.112-6.949,6.949-6.949h103.313 c3.838,0,6.949,3.112,6.949,6.949S425.254,356.676,421.416,356.676z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddVirtualEmail);
export default __webpack_public_path__ + "static/media/add_virtual_email.4619248d8901c4854e646efada1db42a.svg";
export { ForwardRef as ReactComponent };